import styled from 'styled-components';

import { IconPinFilled } from '@u21/tabler-icons';
import { U21Chip } from 'app/shared/u21-ui/components';

import { SavedFilter } from 'app/modules/filters/models';

interface Props {
  applied: boolean;
  disabled?: boolean;
  onClick: () => void;
  pinned: boolean;
  savedFilter: SavedFilter;
}

export const SavedFilterChip = ({
  applied,
  disabled,
  onClick,
  pinned,
  savedFilter,
}: Props) => {
  if (applied) {
    return (
      <U21Chip
        color="primary"
        disabled={disabled}
        icon={pinned ? <IconPinFilled /> : undefined}
        onClick={onClick}
        rounded
        variant="filled"
      >
        {savedFilter.title}
      </U21Chip>
    );
  }
  return (
    <StyledU21Chip
      disabled={disabled}
      icon={pinned ? <StyledIconPinFilled /> : undefined}
      onClick={onClick}
      rounded
      variant="outlined"
    >
      {savedFilter.title}
    </StyledU21Chip>
  );
};

const StyledU21Chip = styled(U21Chip)`
  color: ${(props) => props.theme.palette.text.secondary};

  .MuiChip-icon {
    color: ${(props) => props.theme.palette.text.secondary};
  }
`;

const StyledIconPinFilled = styled(IconPinFilled)`
  color: ${(props) => props.theme.palette.text.secondary};
`;
